module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/orZzD4/media/FC-9781398465534.jpg?1685790893455",
      "alt": "This image is the cover for the book The Unknown Mysterious Cowboy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Unknown Mysterious Cowboy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("I wasn’t really scared until they lifted me from my horse. They didn’t touch me, but they seemed to control everything. I floated from my horse, and I felt nothing. I think if they were intending to kill me they would have already. I counted nine of them, whatever they were. I could see they were moving towards the circle, and as the circle got closer I could just make out a door opening. I could see through the circle as if it were made of glass; as I was taken into the circle I could see many more of them. They were using some kind of flashing table squares. Every time the squares changed colour they used one of their arm-type things to touch the square to change it. I floated further along and could see many more of them using squares on the wall. Just past the squares on the wall I started moving sideways and ended up on a table. I still couldn’t move any part of my body. They removed my gun belt. The belt just undid itself and laid out on a side table. In the end, I had all my clothes removed. None of them touched me, it was as though my clothes had a mind of their own.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Norman Nye\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Norman was born on April 1947. He left school at the age of 15 and served 9 years in the British army. He then started a job as a European HGV driver. Norman went on to running his own business and when he sold that after many years, he was a carpenter. Then eventually, he retired. During the pandemic and having to shield due to age and health, he decided to write a book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0